import {IClubModel} from "@app/pages/clubs/models/club-model";
import {IClubMeetingModel} from "@app/pages/clubs/models/club-meeting-model";
import {IClubCourseAggregateModel} from "@app/pages/clubs/models/club-course-aggregate-model";
import {IClubPollModel} from "@app/pages/clubs/models/club-poll-model";
import {TServiceResult} from "@shared/helper/t-service-result";
import {PageList} from "@shared/model/categoryAndSearch/pageList-model";
import { ResolveFn} from "@angular/router";
import {LocalRepository} from "@shared/helper/local-repository";
import {ClubDetailFacadeService} from "@shared/service/http_services/facades/club-detail.facade.service";
import { inject, makeStateKey, TransferState } from "@angular/core";
import {ActivitiesAggrigatorModel} from "@shared/model/activities-aggrigator-model";

export const STATE_KEY_CLUB_DETAIL = makeStateKey<ClubDetailResolverData>("STATE_KEY_CLUB_DETAIL");


export const ClubDetailResolver: ResolveFn<ClubDetailResolverData> = (route) => {
  const serverState: TransferState = inject(TransferState);
  const _localRepository: LocalRepository = inject(LocalRepository);
  const facade: ClubDetailFacadeService = inject(ClubDetailFacadeService);
  if (!_localRepository.IsInBrowser) {
    return facade.resolveClubDetail(route.paramMap.get('id')!);
  }

  return serverState.get(STATE_KEY_CLUB_DETAIL, ClubDetailResolverData.instanceAllError());
}


export class ClubDetailResolverData {
  club!: TServiceResult<IClubModel>;
  courses!: TServiceResult<PageList<IClubCourseAggregateModel>>;
  activeMeeting!: TServiceResult<PageList<IClubMeetingModel>>;
  activePoll!: TServiceResult<PageList<IClubPollModel>>;
  activities!: TServiceResult<PageList<ActivitiesAggrigatorModel>>;

  public static instance(clubResolverData: any) {
    const data = new ClubDetailResolverData();
    data.club = clubResolverData.club?.hasError ? new TServiceResult<IClubModel>({}, '', null, true, '') : clubResolverData.club;
    data.courses = clubResolverData.previousCourses?.hasError ? new TServiceResult<PageList<IClubCourseAggregateModel>>(new PageList(), '', null, true, '') : clubResolverData.courses;
    data.activeMeeting = clubResolverData.activeMeeting?.hasError ? new TServiceResult<PageList<IClubMeetingModel>>(new PageList(), '', null, true, '') : clubResolverData.activeMeeting;
    data.activePoll = clubResolverData.activePoll?.hasError ? new TServiceResult<PageList<IClubPollModel>>(new PageList(), '', null, true, '') : clubResolverData.activePoll;
    data.activities = clubResolverData.activities?.hasError ? new TServiceResult<PageList<ActivitiesAggrigatorModel>>(new PageList(), '', null, true, '') : clubResolverData.activities;
    return data;
  }

  public static instanceAllError() {
    const data = new ClubDetailResolverData();
    data.club = new TServiceResult<IClubModel>({}, '', null, true, '');
    data.courses = new TServiceResult<PageList<IClubCourseAggregateModel>>(new PageList(), '', null, true, '');
    data.activeMeeting = new TServiceResult<PageList<IClubMeetingModel>>(new PageList(), '', null, true, '');
    data.activePoll = new TServiceResult<PageList<IClubPollModel>>(new PageList(), '', null, true, '');
    data.activities = new TServiceResult<PageList<ActivitiesAggrigatorModel>>(new PageList(), '', null, true, '');
    return data;
  }
}
